import angular from "angular";
import Vue from "vue";
import "ngVue";

import StudentRoadmapPanel from "./StudentRoadmapPanel.vue";

export default angular
  .module("directives.studentroadmappanel", [])
  .directive("dcStudentRoadmapPanel", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(
        Vue.component("DcStudentRoadmapPanel", StudentRoadmapPanel),
      );
    },
  ]);
